import { createRequire } from 'node:module'
//@ts-ignore
export const req = createRequire(import.meta.url)
